<template>
    <div class="alarm-form__details">
        <div class="input-wrapper">
            <label for="" class="alarm-form__label"> Recipients </label>
            <div class="text-field-wrapper">
                <v-text-field
                    v-model="recipient"
                    label="Type recipient"
                    class="small-field input_with-button"
                    :rules="rules.email"
                    ref="emailInput"
                    outline
                    required
                    single-line
                    @keydown.enter="addRecipientEmail"
                >
                </v-text-field>
                <sp-btn text="Add" @click.native="addRecipientEmail" icon="add"></sp-btn>
            </div>
                <v-select
                    multiple
                    required
                    class="hidden-input"
                    v-model="alarmProcessed.recipients"
                    :items="alarmProcessed.recipients"
                    :rules="rules.required"
                ></v-select>
            <div class="alarm-form__email-chips">
                <v-chip
                    v-for="item in alarmProcessed.recipients"
                    :key="item"
                > {{ item }} <v-icon class="alarm-form__icon" @click="onDeleteEmail(item)" small >close</v-icon> </v-chip>
            </div>
        </div>
    </div>
</template>

<script>

import { validateEmail } from '@/helpers/Validators'
import SpBtn from '@/components/forms/SpBtn'

export default {
    name: 'RaiseEvent',
    components: {
        SpBtn
    },
    props: {
        alarmProcessed: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            recipient: '',
            recipients: [],
            rules: {
                email: [
                    v => (!v || validateEmail(v)) || 'Invalid e-mail format.',
                    v => !this.alarmProcessed.recipients.includes(v) || 'This email is already added'
                ],
                subject: [
                    v => 0 < v.length || 'Subject cannot be empty'
                ],
                required: [
                    v => 0 < v.length || 'This field is required'
                ]
            }
        }
    },
    methods: {
        addRecipientEmail () {
            const recipientEmail = this.$refs.emailInput.value
            if (this.$refs.emailInput.valid && ('string' === typeof recipientEmail) && '' !== this.$refs.emailInput.value) {
                this.$emit('addRecipient', recipientEmail)
                this.$refs.emailInput.clearableCallback()
            }
        },
        cropText (text) {
            if (50 < text.length) {
                return text.substring(0, 47) + '...'
            }
            return text
        },
        onDeleteEmail (recipientEmail) {
            this.$emit('deleteRecipient', recipientEmail)
        }
    }
}
</script>
